import { UserProps } from '@img-arena/consoles-api-dde'

import { CheckboxDeleteSelectedItem } from '../CheckboxDeleteSelectedItem'

interface CheckboxDeleteSelectedDDEUserItemProps<T extends UserProps> {
  onDelete: (rows: T[]) => Promise<void> | void
}

export const CheckboxDeleteSelectedDDEUserItem = <T extends UserProps>({
  onDelete
}: CheckboxDeleteSelectedDDEUserItemProps<T>) => (
  <CheckboxDeleteSelectedItem
    onDelete={onDelete}
    renderItem={(row) => `${row.userName} (${row.userId})`}
    successMessage={(rows) => `${rows.length} users deleted successfully`}
    errorMessage={(rows) => `Failed to delete ${rows.length} users`}
    confirmationTitle="Delete Selected Users"
    confirmationMessage="Are you sure you want to delete the following users? This action cannot be undone."
  />
)
